<template>
	<div>
		<!-- <alert-box v-model="alert.alerts" :type="alert.type" /> -->
		<div v-if="value == null">
			<v-layout>
				<btn-a
					rounded
					color="primary"
					class="mt-3"
					@click="$emit('newItem')"
					:access="$access.version.edit"
				>
					<v-icon>mdi-plus</v-icon>
				</btn-a>

				<v-select
					v-model="modelSelected"
					class="ml-5"
					:label="selectLabel"
					:items="itemsComp"
					:item-text="itemText"
					:item-value="itemValue"
					@change="$emit('input', $event)"
					return-object
					clearable
					:loading="loading"
				></v-select>
			</v-layout>
		</div>
		<div v-if="value != null">
			<span>
				<v-btn
					fab
					dark
					small
					color="primary"
					class="mr-2"
					@click="backButtonClick"
				>
					<v-icon>mdi-arrow-left</v-icon>
				</v-btn>
			</span>
			<span>
				<btn-a
					fab
					dark
					small
					class="start ml-5"
					style="margin-right:5px;"
					color="error"
					@click="deleteItem(value)"
					:disable="loading"
					:access="accessDelete"
				>
					<v-icon>mdi-delete</v-icon>
				</btn-a>
			</span>

			<span class="ml-2">
				<btn-a
					rounded
					color="primary"
					class="mt-3"
					id="btnDuplicar"
					@click="newItem(value)"
				>
					<v-icon>mdi-content-duplicate</v-icon>
				</btn-a>
			</span>

			<span>
				<p color="primary" class="headline text-center">
					{{ value[itemText] }}
				</p>
			</span>
		</div>

		<slot v-if="value">
			<!-- <versionForm v-if="itemSelected" ref="form" v-model="itemSelected" /> -->
		</slot>

		<!-- <v-card-actions v-if="value != null">
      <btn-a
        v-if="index > -1 && index != null"
        class="start"
        color="error"
        @click="$emit('delete', value)"
        :disable="loading"
        :access="accessDelete"
        >Delete</btn-a
      >
      <v-spacer />
      <btn-a outlined @click="cancelClick" :disable="loading">{{$t("cancel")}}</btn-a>
      <btn-a
        v-if="confirmButton == true && value != null"
        color="primary"
        outlined
        @click="$emit('confirm')"
        :disable="loading"
        :access="accessConfirm"
        >{{ $t("save") }}</btn-a
      >
    </v-card-actions> -->
	</div>
</template>

<script>
	import pageListMixing from "@/mixins/pageLists/pageListMixing.js";
	import objectValueListMixing from "@/mixins/objectPageLists/objectValueListMixing.js";

	//import versionForm from "@/components/forms/versions/versionForm";
	export default {
		props: [
			"value",
			"items",
			"index",
			"selectLabel",
			"accessConfirm",
			"accessDelete",
			"deleteButton",
			"confirmButton",
			"apiController",
			"idParamName",
			"getAllByIdParam",
			"loading",
			"alert",
			"itemText",
			"itemValue",
			"sort",
		],
		components: {},
		mixins: [pageListMixing, objectValueListMixing],
		data() {
			return {
				modelSelected: {},
				modelStage: {},
				//value: null
			};
		},
		computed: {
			itemsComp() {
				if (this.sort) {
					let itemsSort = [...new Set(this.items)].sort(this.sort);
					return itemsSort;
				} else return this.items;
			},
		},
		// jobStagesSort(a, b) {
		//     if (a.seq > b.seq) return 1
		//     else if (a.seq < b.seq) return -1
		//     else return 0
		// },
		watch: {
			items() {
				this.$emit("input", null);
			},
			value(value) {
				this.modelSelected = value;
			},
		},
		methods: {
			async deleteItem(item) {
				if (this.index > -1 && this.index != null) {
					this.$emit("delete", item);
				} else {
					let res = await this.$confirm();
					if (res) this.$emit("input", null);
				}
			},

			// Atual - Funciona porém está bugado a duplicação do prod stage.
			newItem(model) {
				if (confirm("Are you sure?")) //this.itemSelected = model;
				// console.log("modelStage", this.modelStage);
				// this.modelStage = this.getModelDefault(model);
				// this.$emit("input", this.modelStage);

				localStorage.setItem("duplicateStage", JSON.stringify(model));

				this.$emit('duplicateItem');
				//this.$emit('input', this.getModelDefault(model));
			},

			getModelDefault(model) {
				let fck = {...model}
				return {
					description: "",
					stages: [],
					jobStageItemProds: fck.jobStageItemProds,
					jobStageItemConss: fck.jobStageItemConss,
					jobId: null,
				};
			},

			async backButtonClick() {
				this.$emit("saveChanges", this.value);
			},
			// selectChange(row) {
			//   if (row == null) this.editItem(row, true, true);
			//   else this.editItem(row, true);
			// },
			// async getModelDefault() {
			//   return {
			//     code: await this.getAutoInc(this.apiController),
			//     description: "",
			//     stages: [],
			//     itemId: this.$route.params.itemId
			//   };
			// }
		},

		async mounted() {
			//this.$emit('input', this.modelStage);
			this.$route.params[this.idParamName] = this.jobId;
			//await this.getItems(true);
		},
	};
</script>
